import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RiskScoringService {
  private http = inject(HttpClient);

  getkeyValueList(skip: any) {
    return this.http.get(environment.apiUrl + 'risk_scoring/list?$skip=' + skip + '&$limit=10')
  }
  public deleteRiskScoring(id: any) {
    return this.http.delete(environment.apiUrl+"delete/risk_scoring/"+id)
  }

  saveRiskScoring(scope: any,_id: any){
    if(_id==null)
      return this.http.post(environment.apiUrl + 'save/risk_scoring', scope);
    else
      return this.http.post(environment.apiUrl + 'save/risk_scoring/'+_id, scope);
  }
}
